import * as React from "react";
import { BaseComponent } from "../../../../../../react-core/Html/BaseComponent";
import { arrayToString } from "../../../../../../react-core/Utils/Arrays";
import { FirmType } from "../../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { NetworkType } from "../../../../../../Wrap/Constants/Enums/Network/NetworkType";
import { ServiceProposition } from "../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { Branches } from "../../../../../../Wrap/Models/Domains/Company/Branches";
import { CompanyDetail } from "../../../../../../Wrap/Models/Models/Company/CompanyDetail";
import { ProductPermissions } from "../../../../../../Wrap/Models/Models/Company/ProductPermissions";
import { NetworkHistoryModel } from "../../../../../../Wrap/Models/Models/Network/NetworkHistoryModel";
import { CountryCodeMap } from "../../../../../Shared/Entities/Maps/CountryCodeMap";
import { ServicePropositionMap } from "../../../../../Shared/Entities/Maps/ServicePropositionMap";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { DistributionMap, FsaAuthorisationStatusMap } from "../../../../Network/Resource/Content";
import { CompanyWizardAction } from "../../Actions/CompanyWizardAction";
import { FirmTypeMap, ProductPermissionsArrayMap } from "../../Resource/Content";

interface IFirmDetailProps extends React.Props<FirmDetail> {
    data: CompanyDetail;
}

interface IFirmDetailState {
    currentBranch: Branches;
    network: NetworkHistoryModel;
}

export class FirmDetail extends BaseComponent<IFirmDetailProps, IFirmDetailState> {
    constructor(props: any) {
        super(props);
        this.state = {
            currentBranch: null,
            network: null,
        };
    }

    public componentDidMount() {
        if (this.props.data?.Network != null) {
            const promise = CompanyWizardAction.getNetwork({
                NetworkId: this.props.data.Network,
                NetworkType: NetworkType.Network,
                Max: 1,
                Min: 1,
            });
            promise.onSuccess((networks) => this.setState({ network: networks.networks[0] }));
        }
    }

    private renderProductPermissions(productionPermissions: any[], format: (ele) => any, splitBy?: string) {
        const _array = productionPermissions.map((ele) =>
            ProductPermissionsArrayMap.optionsMap[format(ele)].toString()
        );
        const _splitBy = splitBy || ", ";
        return _array.join(_splitBy);
    }

    private renderBranch(data: Branches) {
        return (
            <>
                <h2>Branch</h2>
                <Typography
                    type="common"
                    config={[
                        { title: "Branch name", data: data.BranchName },
                        { title: "Email address", data: data.EmailAddress },
                    ]}
                />
                <hr />
                {data.PhoneNumber && (
                    <>
                        <h2>Phone number</h2>
                        <Typography
                            type="common"
                            config={[
                                { title: "Country", data: CountryCodeMap.getString(data.PhoneNumber.Country) },
                                { title: "Area Code", data: data.PhoneNumber.AreaCode },
                                { title: "Number", data: data.PhoneNumber.Number },
                            ]}
                        />
                        <hr />
                    </>
                )}
                {data.FaxNumber && (
                    <>
                        <h2>Fax number</h2>
                        <Typography
                            type="common"
                            config={[
                                { title: "Country", data: CountryCodeMap.getString(data.FaxNumber.Country) },
                                { title: "Area Code", data: data.FaxNumber.AreaCode },
                                { title: "Number", data: data.FaxNumber.Number },
                            ]}
                        />
                        <hr />
                    </>
                )}
                <h2>Address</h2>
                <Typography
                    type="common"
                    config={[
                        { title: "Post Code", data: data.Address?.Postcode },
                        { title: "Address Line1", data: data.Address?.Line1 },
                        { title: "Address Line2", data: data.Address?.Line2 },
                        { title: "Address Line3", data: data.Address?.Line3 },
                        { title: "Address Line4", data: data.Address?.Line4 },
                    ]}
                />
            </>
        );
    }

    render() {
        const { data } = this.props;
        const createType =
            data.FirmType == FirmType.AppointedRepresentative || data.FirmType == FirmType.DirectlyAuthorised
                ? "adviser"
                : "thirdParty";

        return (
            <>
                <h2>Firm details</h2>
                <Typography
                    type="common"
                    config={[
                        { title: "Firm name", data: data.CompanyName },
                        { title: "Firm Type", data: FirmTypeMap[data.FirmType] },
                        { title: "Firm ID", data: data.CompanyCode },
                        { title: "Regulated Firm Type", data: data.RegulatedType },
                        { title: "Email Address", data: data.Email },
                        { title: "Distribution Channel", data: DistributionMap[data.DistributionChannel] },
                        { title: "Is Active?", data: data.IsActive ? "Yes" : "No" },
                    ]}
                />
                <hr />
                <h2>Network Details</h2>
                {this.state.network ? (
                    <>
                        <Typography
                            type="common"
                            config={[
                                { title: "Network Name", data: this.state.network?.NetworkName },
                                { title: "FCA/Trading Reference", data: this.state.network?.FcaTradingReference },
                                { title: "Post Code", data: this.state.network?.Address?.Postcode },
                            ]}
                        />
                    </>
                ) : null}
                <hr />
                <h2>Proposition permission</h2>
                <p>Proposition to be permissioned to adviser group</p>
                {arrayToString(data.ServicePropositions, (ele: ServiceProposition) =>
                    ServicePropositionMap.getString(ele)
                )}
                <hr />
                {data.BusinessPhoneNumber && (
                    <>
                        <h2>Phone number</h2>
                        <Typography
                            type="common"
                            config={[
                                { title: "Country", data: CountryCodeMap.getString(data.BusinessPhoneNumber.Country) },
                                { title: "Area Code", data: data.BusinessPhoneNumber.AreaCode },
                                { title: "Number", data: data.BusinessPhoneNumber.Number },
                            ]}
                        />
                        <hr />
                    </>
                )}
                {data.FaxPhoneNumber && (
                    <>
                        <h2>Fax number</h2>
                        <Typography
                            type="common"
                            config={[
                                { title: "Country", data: CountryCodeMap.getString(data.FaxPhoneNumber.Country) },
                                { title: "Area Code", data: data.FaxPhoneNumber.AreaCode },
                                { title: "Number", data: data.FaxPhoneNumber.Number },
                            ]}
                        />
                        <hr />
                    </>
                )}
                <h2>Product permissions</h2>
                <p>Product wrappers to be permissioned to the advisor gourp</p>
                {this.renderProductPermissions(
                    data.ProductPermissions,
                    (ele: ProductPermissions) => ele.ProductPermissionsId
                )}
                <hr />
                <h2>Address</h2>
                <Typography
                    type="common"
                    config={[
                        { title: "Post Code", data: data.Address?.Postcode },
                        { title: "Address Line1", data: data.Address?.Line1 },
                        { title: "Address Line2", data: data.Address?.Line2 },
                        { title: "Address Line3", data: data.Address?.Line3 },
                        { title: "Address Line4", data: data.Address?.Line4 },
                    ]}
                />
                <hr />
                {createType == "adviser" && (
                    <>
                        <h2>FCA authorisation</h2>
                        <Typography
                            type="common"
                            config={[
                                { title: "FCA/Trading Reference", data: data.FSAAuthorisationNumber },
                                //  {title: "Inherit FCA/Trading Status", data: },
                                {
                                    title: "FCA/Trading Status",
                                    data: FsaAuthorisationStatusMap[data.FSAAuthorisationStatus],
                                },
                                //{ title: "LEI Code", data: data.LeiCode },
                                //  {title: "External Reference Code", data:}
                            ]}
                        />
                        <hr />
                    </>
                )}
                <h2>Branches</h2>
                {data.BranchList.length > 0 && (
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Branch name</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {data.BranchList.map((branch, index) => {
                                return (
                                    <tr key={`branch-${index}`}>
                                        <td>{branch.BranchName}</td>
                                        <td>
                                            <button
                                                className="btn secondary mr-5"
                                                onClick={() =>
                                                    this.setState({
                                                        currentBranch: JSON.parse(JSON.stringify(branch)),
                                                    })
                                                }
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
                {this.state.currentBranch && this.renderBranch(this.state.currentBranch)}
            </>
        );
    }
}
